import { UntypedFormControl } from '@angular/forms';

export class ExtendedInformation {
  msr: UntypedFormControl;
  msd: UntypedFormControl;
  cto: UntypedFormControl;
  hsb: UntypedFormControl;
  sta: UntypedFormControl;
  plc: UntypedFormControl;
  rst: UntypedFormControl;
  rpc: UntypedFormControl;
  rcs: UntypedFormControl;
  rct: UntypedFormControl;
  ctp: UntypedFormControl;
  ctq: UntypedFormControl;
  ctr: UntypedFormControl;
  cts: UntypedFormControl;
  hac: UntypedFormControl;
  hts: UntypedFormControl;
  hz1: UntypedFormControl;
  naf: UntypedFormControl;
  tmc: UntypedFormControl;
  cpn: UntypedFormControl;
  ccl: UntypedFormControl;
  cgr: UntypedFormControl;
  cxp: UntypedFormControl;
}
